<template>
  <v-container fluid class="mx-0 px-0">
    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :item-class="rowClass"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: this.$t('Rodyti po:'),
        itemsPerPageAllText: this.$t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :items-per-page="pageSize"
    >
      <template #[`item.pas_pavadinimas`]="{ item }">
        <v-row dense no-gutters>
          <v-col cols="12" md="12">
            {{ item.pas_pavadinimas }}
          </v-col>
          <v-col cols="12" md="12" v-if="item.asmuo_pavadinimas">
            <span class="text-gray">{{ item.asmuo_pavadinimas }}</span>
          </v-col>
        </v-row>
      </template>
      <template #[`item.registras`]="{ item }">
        <div class="nowrap">{{ item.tur_registras }}</div>
        <div class="nowrap">{{ item.tur_identifikatorius }}</div>
      </template>
      <template #[`item.pas_busena`]="{ item }">
        <el-busena :busena="item.pas_busena" />
        {{ item.pas_sukurimo_data }}
      </template>
      <template #[`body.append`]>
        <tr>
          <td :colspan="kainaColSpan" class="text-end">
            <strong
              >{{ $t('Kaina iš viso, EUR') }}:<el-tooltip
                inline
                :tooltip="
                  `${ntrTooltipPrefix} Registravimas. Kaina iš viso, EUR`
                "
            /></strong>
          </td>
          <td class="text-left">{{ visoVerteFormat }}</td>
          <td class="text-left" v-if="showVisoGrazintina">
            {{ visoGrazintinaFormat }}
          </td>
        </tr>
      </template>
      <template slot="loading">
        {{ $t('Kraunasi...') }}
      </template>
      <template slot="no-results">
        {{ $t('Duomenų nėra') }}
      </template>
      <template slot="no-data">
        {{ $t('Duomenų nėra') }}
      </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
        {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import rowClass from '@/mixins/rowClass'
import math from '@/mixins/math'
import tooltipNtr from '@/mixins/tooltipNtr'

export default {
  name: 'PrasymasPaslaugos',
  props: {
    readonly: { type: Boolean, default: false },
  },
  mixins: [rowClass, math, tooltipNtr],
  data() {
    return {
      pageloading: true,
      loading: true,
      search: null,
      paslaugos: [],
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
    }
  },
  computed: {
    ...mapGetters(['prasymasID']),
    headers() {
      return [
        {
          text: this.$t('Prašymo numeris'),
          align: 'start',
          value: 'pas_prasymas',
          width: 100,
        },
        {
          text: this.$t('Paslaugos pavadinimas'),
          align: 'start',
          value: 'pas_pavadinimas',
        },
        {
          text: this.$t('Registro informacija'),
          align: 'start',
          value: 'registras',
          width: 140,
        },
        {
          text: this.$t('Būsena'),
          align: 'center',
          value: 'pas_busena',
          width: 100,
        },
        {
          text: this.$t('Kaina, EUR'),
          align: 'start',
          value: 'kainaFormat',
          width: 50,
        },
        {
          text: this.$t('Grąžintina suma, Eur'),
          align: 'start',
          value: 'grazintinaFormat',
          width: 50,
          hide: !this.showVisoGrazintina,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.paslaugos.map(item => {
        item.kainaFormat = this.moneyformat(item.pas_kaina ?? 0)
        item.grazintinaFormat = this.moneyformat(item.pas_grazintina ?? 0)
        item.pas_busena = item.pas_busena ?? this.$t('Naujas')

        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    visoVerteFormat() {
      return this.moneyformat(
        this.paslaugos
          .map(item => (item.pas_kaina > 0 ? item.pas_kaina : 0))
          .reduce((accumulator, currentValue) => {
            return accumulator + currentValue
          }, 0)
      )
    },
    visoGrazintina() {
      return this.paslaugos
        .map(item => (item.pas_grazintina > 0 ? item.pas_grazintina : 0))
        .reduce((accumulator, currentValue) => {
          return accumulator + currentValue
        }, 0)
    },
    visoGrazintinaFormat() {
      return this.moneyformat(this.visoGrazintina)
    },
    showVisoGrazintina() {
      return this.visoGrazintina > 0
    },
    kainaColSpan() {
      return this.filteredHeaders.length - 1 - (this.showVisoGrazintina ? 1 : 0)
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true
      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.prasymasID}/paslaugos`)
        .then(res => {
          this.paslaugos = res.data.paslaugos
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    updatePaslaugosList() {
      this.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
.duomenys {
  padding-top: 10px;
  padding-bottom: 10px;

  p {
    padding: 3px 0px;
    margin: 0;
  }

  dl {
    display: flex;
    flex-flow: row wrap;
  }
  dt {
    flex-basis: 30%;
    padding: 2px 4px;
    text-align: right;
    font-weight: 400;
  }
  dd {
    flex-basis: 40%;
    flex-grow: 1;
    margin: 0;
    padding: 2px 4px;
    font-weight: 600;
  }
}
</style>
